const POST_ROUTE = '/post'


const Routes = {
    POST_ROUTE,
};
export default Routes;
